import { defineStore } from 'pinia'
import { ref } from 'vue'

export const useAppStore = defineStore('app', () => {
  const drawer = ref(false)
  const loading = ref(false)
  const error = ref<string | null>(null)

  function toggleDrawer() {
    drawer.value = !drawer.value
  }

  function setLoading(value: boolean) {
    loading.value = value
  }

  function setError(message: string | null) {
    error.value = message
  }

  function clearError() {
    error.value = null
  }

  return {
    drawer,
    loading,
    error,
    toggleDrawer,
    setLoading,
    setError,
    clearError,
  }
})
